import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { ScenarioPageRoutingModule } from "./scenario-routing.module";
import { ScenarioPage } from "./scenario.page";
import { LogoModule } from "src/app/components/logo/logo.module";
import { ScenarioPageModule as ScenarioModalModule } from "src/app/modals/scenario/scenario.module";
import { RouterModule } from "@angular/router";
import { ActionSelectorPageModule } from "src/app/modals/action-selector/action-selector.module";
import { TranslateModule } from "@ngx-translate/core";
import { ToTreeModule } from "./pipes/to-tree/to-tree.module";
import { ScenarioLogsPageModule } from "src/app/modals/scenario-logs/scenario-logs.module";
import { MultiActionPageModule } from "src/app/modals/multi-action/multi-action.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule,
    ScenarioPageRoutingModule,
    LogoModule,
    ToTreeModule,
    ScenarioModalModule,
    ActionSelectorPageModule,
    TranslateModule,
    ScenarioLogsPageModule,
    MultiActionPageModule,
  ],
  declarations: [ScenarioPage],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ScenarioPageModule {}
